import styles from './Input.module.css';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = ({ className, ...props }: InputProps): React.JSX.Element => (
    <input className={`${styles.input}${className ? ` ${className}` : ''}`} {...props} />
);

export { Input };
